import { useDeviceListODataServer } from "@/api/odata/odata-hooks.gen";
import type { DeviceDto } from "@/api/openapi";
import { DeviceDtoDeviceType } from "@/api/query.schemas";

export type UseSiteCoreDeviceResult = {
    /** All CORE devices tagged to the site (a site may have more than one). */
    cores: DeviceDto[];
    isLoading: boolean;
    isError: boolean;
};

/**
 * Resolves the CORE devices for a site (`deviceGroupTag`) from the cached
 * `/devices-odata` list (`deviceType eq 'Core'` + the site tag). Shared by the
 * device-group sidebar and the site page CORE status badge.
 */
export const useSiteCoreDevice = (
    deviceGroupTag: string | undefined,
    options?: { enabled?: boolean },
): UseSiteCoreDeviceResult => {
    const enabled = (options?.enabled ?? true) && !!deviceGroupTag;

    const {
        data: cores,
        isLoading,
        isError,
    } = useDeviceListODataServer(
        {
            filters: [
                {
                    field: "deviceType",
                    op: "eq",
                    value: DeviceDtoDeviceType.Core,
                },
                {
                    field: "deviceGroupTags",
                    op: "anyEq",
                    value: deviceGroupTag ?? "",
                },
            ],
            orderby: [{ field: "deviceIdentity" }],
        },
        { enabled },
    );

    return { cores, isLoading, isError };
};

export default useSiteCoreDevice;
